import React, { useRef, useState } from 'react'
import Dropzone from 'react-dropzone'
import cx from 'classnames'
import CloudUpload from '@material-ui/icons/CloudUpload'

const UploadDropZone = ({ setFileSelected, setFileName, fileSelected, fileName }) => {
  const dropZoneRef = useRef('dropzone')
  const [isDragging, setIsDragging] = useState(false)

  const handleOnDrop = ([file]) => {
    setFileSelected(file || null)
    setFileName(file.name ? file.name : null)
  }

  return (
    <div
      className='b--dashed b--grey'
      onDragOver={() => setIsDragging(true)}
      onDragLeave={() => setIsDragging(false)}
    >
      <div className='bg-white h12'>
        <Dropzone
          className='absolute'
          ref={dropZoneRef}
          name='file'
          onDrop={handleOnDrop}
          multiple={false}
        >
          {({ getRootProps, getInputProps }) => (
            <section
              className={cx(
                'w-100 h12',
                { 'bg-pale-green': fileSelected },
                { 'hover-bg-precedents-blue-20 pointer': !fileSelected },
                { 'bg-precedents-blue-20': isDragging && !fileSelected },
                { 'bg-precedents-blue-5': !isDragging && !fileSelected }
              )}
            >
              <div
                className='relative top-50 y--50 tc'
                {...getRootProps()}
              >
                <input {...getInputProps()} />
                {fileName
                  ? fileSelected
                    ? <div>File selected: <strong>{fileName}</strong></div>
                    : <div>Existing file: <strong>{fileName}</strong></div>
                  : <DragToUpload />}
              </div>
            </section>
          )}
        </Dropzone>
      </div>
    </div>
  )
}

const DragToUpload = () => (
  <div className={cx('precedents-blue')}>
    <CloudUpload style={{ height: 48, width: 48 }} className='o-70' />
    <div className='f4'>
      Drag file here or click to upload.
    </div>
  </div>
)

export default UploadDropZone
